/* eslint-disable sonarjs/no-duplicate-string */
export interface IRandomPhrase {
  author: string;
  description: string;
}

export const randomPhrase: IRandomPhrase[] = [
  {
    author: 'José de Alencar',
    description:
      'O sucesso nasce do querer, da determinação e persistência em se chegar a um objetivo. Mesmo não atingindo o alvo, quem busca e vence obstáculos, no mínimo fará coisas admiráveis',
  },

  {
    author: 'Ayrton Senna',
    description: 'Se você quer ser bem-sucedido precisa de dedicação total, buscar seu último limite e dar o melhor de si mesmo',
  },
  {
    author: 'Mary Kay Ash',
    description:
      'Não crie limites para si mesmo. Você deve ir tão longe quanto sua mente permitir. O que você mais quer pode ser conquistado',
  },
  {
    author: 'C.S Lewis',
    description: 'Dificuldades preparam pessoas comuns para destinos extraordinários',
  },
  {
    author: 'Andrew Carnegie',
    description: 'Nenhum homem será um grande líder se quiser fazer tudo sozinho ou se quiser levar todo o crédito por fazer isso',
  },
  {
    author: 'Dalai Lama',
    description: 'Só existem dois dias do ano em que você não pode fazer nada: um se chama ontem e outro amanhã',
  },
  {
    author: 'José Roberto Marques',
    description: 'Ouse ir além, ouse fazer diferente e o poder lhe será dado!',
  },
  {
    author: 'Clarice Lispector',
    description:
      'Ouse, arrisque, não desista jamais e saiba valorizar quem te ama, esses sim merecem seu respeito. Quanto ao resto, bom, ninguém nunca precisou de restos para ser feliz',
  },
  {
    author: 'Muhammad Ali',
    description: 'Para ser um campeão você tem que acreditar em si mesmo quando ninguém mais acredita',
  },
  {
    author: 'Mahatma Gandhi',
    description: 'Você nunca sabe que resultados virão da sua ação. Mas se você não fizer nada, não existirão resultados',
  },
  {
    author: 'Winston Churchill',
    description: 'O pessimista vê dificuldade em toda oportunidade. O otimista vê oportunidade em toda dificuldade',
  },
  {
    author: 'Bill Gates',
    description: 'A paciência é um elemento fundamental do sucesso',
  },
  {
    author: 'Jeff Bezos',
    description: 'Reclamar não é uma estratégia. É necessário lidarmos com o mundo como ele é e não como gostaríamos que ele fosse',
  },
  {
    author: 'Michelle Obama',
    description:
      'O sucesso não tem a ver com o lugar de onde você veio, e sim com a confiança que você tem e o esforço que você está disposto a investir',
  },
  {
    author: 'Steve Jobs',
    description: 'Você pode encarar um erro como uma besteira a ser esquecida, ou como um resultado que aponta uma nova direção',
  },
  {
    author: 'Michael Jordan',
    description: 'Eu posso aceitar a falha, todos falham em alguma coisa. Mas eu não posso aceitar não tentar',
  },
  {
    author: 'Stephen Hawking',
    description: 'Inteligência é a capacidade de se adaptar às mudanças',
  },
  {
    author: 'Henry Ford',
    description: 'Nossos fracassos, às vezes, são mais frutíferos do que os êxitos',
  },
  {
    author: 'Margaret Thatcher',
    description:
      'Gostaria que você soubesse que existe dentro de si uma força capaz de mudar sua vida. Basta que lute e aguarde um novo amanhecer',
  },
  {
    author: 'Sônia Hess',
    description: 'É preciso ser protagonista. Não dá para ficar só ouvindo a banda passar, temos de ser parte da banda',
  },
  {
    author: 'Napoleão Bonaparte',
    description: 'A arte de ser ora audacioso, ora prudente, é a arte de vencer',
  },
  {
    author: 'Emma Watson',
    description:
      'Só se aprende com a experiência. Portanto, não importa o que as pessoas lhe digam, você tem que viver e cometer seus próprios erros para aprender',
  },
  {
    author: 'Bill Gates',
    description: 'Toda empresa precisa ter gente que erra, que não tem medo de errar e que aprende com erro',
  },
  {
    author: 'Hillary Clinton',
    description:
      'Quando você tropeçar, mantenha a fé. Quando for nocauteado, levante rápido. Não ouça quem diz que você não pode ou não deve continuar',
  },
  {
    author: 'John F. Kennedy',
    description: 'Somente os que ousam errar muito podem realizar muito',
  },
  {
    author: 'Eleanor Roosevelt',
    description: 'Você precisa fazer aquilo que pensa que não é capaz de fazer',
  },
  {
    author: 'Theodore Roosevelt',
    description: 'Faça o que puder, com o que tiver, onde estiver.',
  },
  {
    author: 'Dalai Lama',
    description: 'Lembre-se que não conseguir o que você quer é algumas vezes um lance de sorte',
  },
  {
    author: 'William Shakespeare',
    description: 'Nossas dúvidas são traidoras e nos fazem perder, por medo de tentar, o que poderíamos ganhar',
  },
  {
    author: 'Walt Disney',
    description: 'É sempre divertido fazer o impossível',
  },
  {
    author: 'Henry Ford',
    description: 'O insucesso é uma oportunidade para recomeçar com mais inteligência',
  },
  {
    author: 'Henry Ford',
    description: 'Não encontre defeitos, encontre soluções. Qualquer um sabe queixar-se',
  },
  {
    author: 'Ayrton Senna',
    description: 'Na adversidade, uns desistem, enquanto outros batem recordes',
  },
  {
    author: 'Ayrton Senna',
    description: 'Eu não tenho Ídolos. Tenho admiração por trabalho, dedicação e competência',
  },
  {
    author: 'Steve Jobs',
    description: 'Seu tempo é limitado, então não perca tempo vivendo a vida de outra pessoa',
  },
  {
    author: 'Albert Einstein',
    description: 'Espíritos grandiosos sempre encontraram oposição violenta de mentes medíocres',
  },
  {
    author: 'Santos Dumont',
    description: 'As invenções são o resultado de um trabalho teimoso',
  },
  {
    author: 'Albert Einstein',
    description: 'Esforce-se para não ser um sucesso, mas sim para ser valioso',
  },
  {
    author: 'Albert Einstein',
    description: 'Uma pessoa que nunca cometeu um erro, nunca tentou nada de novo',
  },
];
